import { Component, Input, OnInit } from '@angular/core';

import { IHelpCard } from '../../../models/help-card.interface';

@Component({
  selector: 'app-help-card',
  templateUrl: './help-card.component.html',
  styleUrls: ['./help-card.component.css'],
})
export class HelpCardComponent implements OnInit {
  @Input()
  public card: IHelpCard | undefined;

  @Input()
  public type: string | undefined;

  protected get borderType(): string {
    return this.type === 'secondary' ? 'border-2 ' : '';
  }

  constructor() {}

  ngOnInit(): void {}
}
